<div *ngIf="showVehicleNeedsForm" data-testid="warranty-vehicle-needs-section">

  <form class="auto-fit-layout mb-3"
        [formGroup]="vehicleNeedsForm"
        data-testid="warranty-vehicle-needs-form">
    <div data-testid="warranty-dropdown-row-planned-length">
      <label>Planned Length of Ownership</label>
      <select class="form-control"
              formControlName="plannedLengthOfOwnership"
              (change)="autoSubmitVehicleNeedsForm('plannedLengthOfOwnership')"
              data-testid="warranty-dropdown-planned-length-of-ownership">
        <option *ngFor="let option of yearsOptions"
                [value]="option.years">
          {{ option.title }}
        </option>
      </select>
    </div>

    <div data-testid="warranty-dropdown-row-miles-per-year">
      <label class="d-flex align-items-center justify-content-between">
        Miles Driven Per Year
        <a [routerLink]="[]"
           class="small"
           (click)="onToggleCalculator()">
          Calculate
        </a>
      </label>
      <select class="form-control"
              formControlName="milesDrivenPerYear"
              (change)="autoSubmitVehicleNeedsForm('milesDrivenPerYear')"
              data-testid="warranty-dropdown-miles-driven-per-year">
        <option *ngFor="let option of milesOptions"
                [value]="option.miles">
          {{ option.title }}
        </option>
      </select>
    </div>
  </form>

  <form *ngIf="showInsuranceProductsForm"
        [formGroup]="insuranceProductsForm"
        class="auto-fit-layout mb-3"
        data-testid="warranty-insurance-products-form">
    <div *ngFor="let product of insuranceProducts"
         [attr.data-testid]="'warranty-product-row-' + product.productKey">
      <div>
        <label class="pr-2">{{ product.name }}</label>
        <app-tooltip-icon *ngIf="product.isFallbackTermCosts" type="error" icon="error" iconClass="material-symbols-outlined">
          <span>Product not found, displaying default terms</span>
        </app-tooltip-icon>
      </div>
      <select class="form-control"
              [class.error]="product.isFallbackTermCosts"
              formControlName="{{ product.productKey }}"
              (change)="autoSubmitInsuranceProductsForm(product)"
              [attr.data-testid]="'warranty-product-select-' + product.productKey">
        <!-- Use grouped options for VSC products with product names -->
        <ng-container *ngIf="isVSCProduct(product) && hasProductNames(product)">
          <optgroup *ngFor="let group of getGroupedTermCosts(product)" [label]="group.productName">
            <option *ngFor="let item of group.termCosts" [ngValue]="item.index">
              {{ item.termCost.term / 12 }} Years / {{ item.termCost.miles >= 999999 ? 'Unlimited' : (item.termCost.miles | number) }} Miles
            </option>
          </optgroup>
        </ng-container>
        <!-- Use flat list for non-VSC products or VSC without product names -->
        <ng-container *ngIf="!isVSCProduct(product) || !hasProductNames(product)">
          <option *ngFor="let option of getSortedTermCosts(product); let i = index"
                  [ngValue]="i">
            {{ option.term / 12 }} Years / {{ option.miles >= 999999 ? 'Unlimited' : (option.miles | number) }} Miles
          </option>
        </ng-container>
      </select>
    </div>
  </form>

</div>

<div *ngIf="showCalculator"
     class="mb-3">
  <app-miles-per-year-calculator></app-miles-per-year-calculator>
</div>
